import { Card, Divider } from "antd";
import { ClipboardCheck, Calendar } from "lucide-react";

const workStatsData = [
  {
    id: 1,
    label: "Total Work Hours",
    value: "152.5 hrs",
    details: [
      { name: "Regular Hours", value: "148 hrs" },
      { name: "Overtime", value: "4.5 hrs", color: "text-blue-600" },
    ],
    icon: <ClipboardCheck className="w-5 h-5" />,
    textColor: "text-green-600",
  },
  {
    id: 2,
    label: "Lunch Breaks",
    value: "19.0 hrs",
    details: [
      { name: "Total Breaks", value: "19 breaks" },
      { name: "Avg. Duration", value: "60 mins" },
    ],
    icon: <Calendar className="w-5 h-5" />,
    textColor: "text-amber-600",
  },
  {
    id: 3,
    label: "Tardiness",
    value: "45 mins",
    details: [
      { name: "Late Days", value: "1/19" },
      { name: "Max Delay", value: "45 mins" },
    ],
    icon: <ClipboardCheck className="w-5 h-5 text-red-600" />,
    iconBg: "bg-red-100 dark:bg-red-900/30",
    textColor: "text-red-600",
  },
];

export default function WorkStatusGrid() {
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-10 px-1">
      {workStatsData.map((item) => (
        <Card
          key={item.id}
          className="flex flex-col gap-6 rounded-xl border border-slate-200"
          bodyStyle={{ padding: 16 }}
        >
          <div className="flex items-center gap-3 mb-3">
            <div className={`p-2 bg-text ${item.label.toLowerCase().replace(/\s+/g, "-")}`}>{item.icon}</div>
            <div>
              <p className="text-xs">{item.label}</p>
              <p className={`text-lg font-bold ${item.textColor}`}>{item.value}</p>
            </div>
          </div>

          <div className="shrink-0 h-px w-full my-2"></div>
      <Divider style={{ margin: "0.5rem 0", borderColor: "#e5e7eb" }} />

          <div className="space-y-1 text-xs">
            {item.details.map((d, i) => (
              <div key={i} className="flex justify-between">
                <span>{d.name}:</span>
                <span className={`font-semibold ${d.color}`}>{d.value}</span>
              </div>
            ))}
          </div>
        </Card>
      ))}
    </div>
  );
}
